// Raíz de la aplicación (T-001-05 & SPEC-002).
//
// Permite alternar libremente entre la experiencia de aula (Juego Episodio 1)
// y el Panel del Facilitador para la gestión docente.

import { useState } from "react";
import GameShell from "./game/GameShell";
import { PanelShell } from "./panel/PanelShell";

// Acceso oculto temporalmente por decisión de producto (2026-10-12). El panel
// y su implementación se conservan; volver a `true` cuando se solicite.
const MOSTRAR_ACCESO_PANEL_FACILITADOR = false;

export default function App() {
  const [modo, setModo] = useState<"juego" | "panel">("juego");
  const parametrosDeAuditoria = import.meta.env.DEV && typeof window !== "undefined"
    ? new URLSearchParams(window.location.search)
    : null;
  const auditoriaVisual = parametrosDeAuditoria !== null && (
    parametrosDeAuditoria.get("auditWorld") === "1" ||
    parametrosDeAuditoria.has("auditIsland")
  );

  if (modo === "panel") {
    return <PanelShell onReturnToGame={() => setModo("juego")} />;
  }

  return (
    <div style={{ position: "relative" }}>
      {/* Botón flotante para acceder al Panel del Facilitador desde el juego */}
      {!auditoriaVisual && MOSTRAR_ACCESO_PANEL_FACILITADOR ? (
        <button
          onClick={() => setModo("panel")}
          aria-label="Ir al Panel del Facilitador"
          className="app__facilitator-link"
        >
          <span aria-hidden="true">📋</span> Panel Facilitador
        </button>
      ) : null}

      <GameShell />
    </div>
  );
}
